import UploadBanner  from  './UploadBanner'

export default UploadBanner